import { render } from "./DaftarStatus.vue?vue&type=template&id=314ef5b4"
import script from "./DaftarStatus.vue?vue&type=script&lang=js"
export * from "./DaftarStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__